<template>
  <v-card>
    <v-card-title>
      <span>
        <v-icon>mdi-star</v-icon> SEO
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <seo-description></seo-description>
      <br>
      <seo-keywords></seo-keywords>
    </v-card-text>
  </v-card>
</template>
<script>
  import SeoKeywords from './SeoKeywords'
  import SeoDescription from './SeoDescription'

  export default {
    name: 'ArticleSeo',
    components: {
      SeoKeywords,
      SeoDescription
    },
    data() {
      return {}
    }
  }
</script>